import React, { useCallback } from 'react'
import { Link } from 'react-router-dom'
import { DeleteOutlined } from '@ant-design/icons'
import { Button, Popconfirm } from 'antd'
import PropTypes from 'prop-types'

import { PermissionGuard } from '../../../common/components/routes'
import { APP_ROUTES, PERMISSIONS } from '../../../common/constants'

import { ingredientSpecialCasePropType } from '../../prop-types'

const IngredientSpecialCasesTableActionColumn = ({
  ingredientSpecialCase,
  onDelete,
}) => {
  const handleDeleteIngredientSpecialCase = useCallback(
    () => onDelete(ingredientSpecialCase.id),
    [onDelete, ingredientSpecialCase.id],
  )

  return (
    <>
      <Button>
        <Link
          to={`${APP_ROUTES.INGREDIENTS.subMenuItems.INGREDIENT_SPECIAL_CASES.link}/${ingredientSpecialCase.id}`}
        >
          View
        </Link>
      </Button>
      <PermissionGuard permissions={PERMISSIONS.INGREDIENT_SPECIAL_CASE.DELETE}>
        <Popconfirm
          title="Are you sure you want to delete this Special case?"
          onConfirm={handleDeleteIngredientSpecialCase}
          placement="left"
          okText="Yes"
          cancelText="No"
        >
          <Button>
            <DeleteOutlined />
          </Button>
        </Popconfirm>
      </PermissionGuard>
    </>
  )
}

IngredientSpecialCasesTableActionColumn.propTypes = {
  ingredientSpecialCase: ingredientSpecialCasePropType.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default IngredientSpecialCasesTableActionColumn
